import Choices from "choices.js";

const choicesInstances = [];

const renderChoiceRow = strToEl => (classNames, data, itemSelectText) => {
  const disabled = data.disabled || data.selected;
  const cssClasses = [
    classNames.item,
    classNames.itemChoice,
    disabled ? classNames.itemDisabled : classNames.itemSelectable,
    data.placeholder ? classNames.placeholder : "",
  ].join(" ").trim();

  return strToEl(`
    <div class="${cssClasses}"
      data-select-text="${itemSelectText}"
      data-choice
      data-id="${data.id}"
      data-value="${data.value}"
      ${disabled ? 'data-choice-disabled aria-disabled="true"' : "data-choice-selectable"}
      id="${data.elementId}"
      role="${data.groupId > 0 ? "treeitem" : "option"}">
      ${data.label}
    </div>
  `);
};

// Choices keeps the underlying <select multiple> in sync with the chosen chips
// (it rewrites the element's <option> list to exactly the selected values on
// every change), so the browser submits assignments_attributes[][administrator_id]
// natively. No hidden-field bookkeeping is needed here.

document.addEventListener("turbo:before-cache", () => {
  choicesInstances.forEach(({ instance, element, originalHTML }) => {
    try { instance.destroy(); } catch (_) {}
    // destroy() resets the <select> to its (empty) preset choices, wiping the
    // server-rendered <optgroup>s. Restore them so a restored cache snapshot
    // re-initialises against a populated select instead of an empty one.
    if (element && originalHTML != null) element.innerHTML = originalHTML;
  });
  choicesInstances.length = 0;
});

export const destroyAdministratorMultiSelect = root => {
  if (!root) return;
  for (let i = choicesInstances.length - 1; i >= 0; i--) {
    const { instance, element } = choicesInstances[i];
    if (element && root.contains(element)) {
      try { instance.destroy(); } catch (_) {}
      choicesInstances.splice(i, 1);
    }
  }
};

const initAdministratorMultiSelect = (elements = document.querySelectorAll("[data-administrator-multi-select]")) => {
  Array.from(elements).forEach(element => {
    if (element.getAttribute("data-choice") === "active") return;
    const originalHTML = element.innerHTML;

    const instance = new Choices(element, {
      removeItems: true,
      removeItemButton: true,
      placeholder: true,
      placeholderValue: element.dataset.placeholder,
      itemSelectText: "",
      searchEnabled: true,
      renderSelectedChoices: "always",
      callbackOnCreateTemplates: strToEl => ({ choice: renderChoiceRow(strToEl) }),
    });
    choicesInstances.push({ instance, element, originalHTML });
  });
};

export default initAdministratorMultiSelect;
